import { DotWave } from "@uiball/loaders";
import { useState } from "react";
import styled from "styled-components";
import FlexColumn from "../../../components/FlexColumn";
import FlexRow from "../../../components/FlexRow";
import CloseXButton from "../components/CloseXButton";
import Divider from "../components/Divider";
import ModalHeading2 from "../components/ModalHeading2";
import InviteSuccessModal from "./InviteSuccessModal";

const Image = styled.img`
  max-width: 11.25rem;
  margin-top: 3.5rem;
  margin-bottom: 2.25rem;
`;

const Heading = styled.p`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 160%; /* 2.4rem */
  letter-spacing: -0.03125rem;
  color: ${({ theme }) => theme.grayScaleColor.gray80};
  text-align: center;
`;

const DescriptionText = styled.p`
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 170%; /* 1.59375rem */
  letter-spacing: -0.03125rem;
  text-align: center;
  color: ${({ theme }) => theme.grayScaleColor.gray80};
  margin-top: 1.25rem;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.87rem;
  background: ${({ theme }) => theme.grayScaleColor.gray5};
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 170%; /* 1.59375rem */
  letter-spacing: -0.03125rem;
  color: ${({ theme }) => theme.grayScaleColor.gray80};
  margin-top: 1.81rem;
  border-radius: 0.4375rem;
`;

const Separator = styled.div`
  width: 1px;
  height: 1rem;
  background: ${({ theme }) => theme.grayScaleColor.gray30};
  margin: 0 0.5rem;
`;
const ModalButton = styled.button`
  border-radius: 0.4375rem;
  padding: 0.78rem 0;
  flex: 1;
  // max-width: 11rem;
  border: none;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.4375rem; /* 153.333% */
  letter-spacing: -0.0375rem;
  cursor: pointer;
`;

const CancelButton = styled(ModalButton)`
  background: ${({ theme }) => theme.grayScaleColor.gray10};
  color: ${({ theme }) => theme.backgroundColor.darkgray40};
  &:disabled {
    opacity: 0.3;
  }
`;

const OkButton = styled(ModalButton)`
  background: ${({ theme }) => theme.primary.normal};
  color: ${({ theme }) => theme.grayScaleColor.white};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IndividualInviteModal = ({ users, closeHandler, confirmHandler }) => {
  const [isConfirmClicked, setIsConfirmClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onConfirmClick = async () => {
    setIsLoading(true);
    await confirmHandler();
    setIsConfirmClicked(true);
  };
  if (isConfirmClicked) {
    return <InviteSuccessModal closeHandler={closeHandler} users={users} />;
  }

  return (
    <>
      <FlexRow
        style={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <FlexRow style={{ gap: "0.5rem" }}>
          <ModalHeading2 text="초대하기" />
        </FlexRow>
        <CloseXButton onClick={closeHandler} />
      </FlexRow>
      <FlexRow style={{ justifyContent: "center" }}>
        <Image
          src={`${process.env.PUBLIC_URL}/assets/dashboard/manager/send_plane.png`}
        />
      </FlexRow>
      <Heading>
        {users.length === 1
          ? `${users[0].name} 님에게`
          : `${users[0].name} 님 외${users.length - 1}명`}
        <br /> 맘핏 초대장을 보내시겠어요?
      </Heading>
      {users.length === 1 && (
        <DescriptionText>{users[0].email}</DescriptionText>
      )}
      <FlexRow
        style={{
          marginTop: "3.12rem",
          justifyContent: "space-between",
          gap: "0.69rem",
        }}
      >
        <CancelButton onClick={closeHandler} disabled={isLoading}>
          나중에 초대하기
        </CancelButton>
        <OkButton onClick={onConfirmClick}>
          {isLoading ? (
            <DotWave size={40} speed={1} color="#FFF" />
          ) : (
            "지금 초대하기"
          )}
        </OkButton>
      </FlexRow>
    </>
  );
};

export default IndividualInviteModal;
